<template>
  <aside>
    <Close
      class="close-button"
      @click="$emit('close')"
    />
    <strong>{{ title }}</strong>
    <p>{{ description }}</p>
  </aside>
</template>
<script>
import Close from '@/assets/images/common/icons/close.svg?inline';

export default {
  name: 'HotspotOverlay',
  components: {
    Close,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
  },
};
</script>
<style lang="stylus" scoped>
aside {
  position: relative;
  background: var(--white-color);
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 40px 20px 20px;
  gap: 15px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);

  strong {
    font-size: 18px;
    font-weight: 700;
  }

  p {
    text-align: left;
    font-size: 14px;
    font-weight: 400;
  }

  .close-button {
    position: absolute;
    top: 10px;
    right: 10px;
    background: var(--main-color);
    border: 1px solid var(--main-color);
    border-radius: 50%;
    width: 40px;
    height: 40px;
    padding: 8px;
    cursor: pointer;
    transition: background 0.2s ease;
    g g {
      stroke: var(--white-color);
    }
    &:hover {
      background: var(--white-color);
      g g {
        stroke: var(--main-color);
      }
    }
  }
}
</style>
